import classes from './RadioButton.module.css';

const RadioButton = ({ label, name, value, checked, onChange, disabled }) => {
  return (
    <div className={classes.selectAnswerContainer}>
        <label className={classes.customRadio}>
            {label}
            <input type="radio" name={name} value={value} checked={checked} onChange={onChange} disabled={disabled}/>
            <span></span>
        </label>
    </div>
  );
}

export default RadioButton;